export const bracketsToHtml = (str: string) =>
  str.replace(/\[/g, '<').replace(/]/g, '>')
